module.exports = __webpack_public_path__ + "static/gevorg-ce0a32e1dcd388fe2c3f91650a6c6277.png";